<template>
    <div>
        <b-modal
            id="modalInfo"
            v-model="isOpen"
            modal-class="modalInfo"
            :title="$t(modalInfo.title)"
            @show="openModal"
            @hide="clearModal()"
        >
            <b-container v-if="!success">
            <b-row>
                <b-col>
                <b-form @submit.prevent="">
                    <b-container v-if="!editMode && type === 'single'">
                    <b-form-group label-class="text-sm-left">
                        <template slot="label">
                        <!--title-->
                        {{$t("label_evaluation_administrator_evaluations_selectOrganization")}}
                        </template>
                        <b-form-select
                        id="label_evaluation_administrator_evaluations_selectOrganization"
                        v-model="selectedBusiness"
                        style="width: 100%"
                        >
                        <option :value="null" />
                        <option
                            v-for="(businessU, indexBuss) of business"
                            :key="indexBuss"
                            :value="businessU.id"
                        >
                            {{ businessU.name }}
                        </option>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label-class="text-sm-left">
                        <template slot="label">
                        <!--title-->
                        {{$t("label_evaluation_administrator_evaluations_selectSnapshot")}}
                        </template>
                        <b-form-select
                        id="label_evaluation_administrator_evaluations_selectSnapshot"
                        v-model="model.snapshotId[0]"
                        style="width: 100%"
                        >
                        <option :value="null" />
                        <option
                            v-for="(snapshot, indexSS) of snapshots"
                            :key="indexSS"
                            :value="snapshot.snapshotId"
                        >
                            {{ snapshot.date }}
                        </option>
                        </b-form-select>
                    </b-form-group>
                    <form-error
                        :errors="errors['snapshotId']"
                        :field-name="'snapshotId'"
                    />
                    </b-container>
                    <b-container v-if="!editMode && type === 'multi'">
                    <b-row>
                        <b-col>
                        <b-form-group label-class="text-sm-left">
                            <template slot="label">
                            <!--title-->
                            {{
                                $t(
                                "label_evaluation_administrator_evaluations_selectTag"
                                )
                            }}
                            </template>
                            <b-form-select
                            id="label_evaluation_administrator_evaluations_selectTag"
                            v-model="selectedTag"
                            style="width: 100%"
                            >
                            <option
                                v-for="(tag, indexTg) of tags"
                                :key="indexTg"
                                :value="tag.id"
                            >
                                {{ tag.name }}
                            </option>
                            </b-form-select>
                        </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="business.length > 0">
                        <b-col>{{$t('label_evaluation_administrator_evaluations_organizations')}}</b-col>
                        <b-col>{{$t('label_evaluation_administrator_evaluations_snapshots')}}</b-col>
                    </b-row>
                    <b-row v-for="(businessU, index) of business" :key="index">
                        <b-col cols="6" class="business" style="text-align: left">
                        <b-form-checkbox
                            v-model="selectedBusinessMulti[index]"
                            name="check-button"
                            switch
                            size="lg"
                        >
                            <span class="businessName">
                            {{ businessU.name }}
                            </span>
                        </b-form-checkbox>
                        </b-col>
                        <b-col cols="6" style="text-align: left">
                        <b-row
                            v-for="(snapshot, indexS) of businessU.snapShots"
                            :key="indexS"
                        >
                            <b-form-radio
                            v-model="model.snapshotId[index]"
                            :name="'snapshot-' + index"
                            :value="snapshot.id"
                            :disabled="!selectedBusinessMulti[index]"
                            >
                            <span v-if="snapshot" class="businessName">
                                {{ snapshot.startDate }} -
                                {{ snapshot.endDate }}</span
                            >
                            </b-form-radio>
                        </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <form-error
                        :errors="errors['snapshotId']"
                        :field-name="'snapshotId'"
                        />
                    </b-row>
                    </b-container>
                    <b-container v-if="editMode">
                    <b-row v-if="selectedTag">
                        <b-col>
                        <b-form-group label-class="text-sm-left">
                            <template slot="label">
                            <!--title-->
                            {{
                                $t(
                                "label_evaluation_administrator_evaluations_selectTag"
                                )
                            }}
                            </template>
                            <b-form-select
                            id="label_evaluation_administrator_evaluations_selectTag"
                            v-model="selectedTag"
                            :disabled="true"
                            style="width: 100%"
                            >
                            <option
                                v-for="(tag, indexTg) of tags"
                                :key="indexTg"
                                :value="tag.id"
                            >
                                {{ tag.name }}
                            </option>
                            </b-form-select>
                        </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="selectedBusinessList.length > 0">
                        <b-col>{{$t('label_evaluation_administrator_evaluations_organizations')}}</b-col>
                        <b-col>{{$t('label_evaluation_administrator_evaluations_snapshots')}}</b-col>
                    </b-row>
                    <b-row
                        v-for="(selectedB, indexSB) in selectedBusinessList"
                        :key="indexSB"
                    >
                        <b-col>{{ selectedB.name }}</b-col>
                        <b-col
                        ><span v-if="selectedB.snapshot"
                            >{{ selectedB.snapshot.startDate }} -
                            {{ selectedB.snapshot.endDate }}</span
                        ></b-col
                        >
                    </b-row>
                    </b-container>
                    <b-container>
                    <b-form-group label-class="text-sm-left">
                        <template slot="label">
                        <!--title-->
                        {{
                            $t(
                            "label_evaluation_administrator_evaluations_selectEvaluationModel"
                            )
                        }}
                        </template>
                        <b-form-select
                        id="label_evaluation_administrator_evaluations_selectEvaluationModel"
                        v-model="selectedModel"
                        style="width: 100%"
                        :disabled="editMode"
                        >
                        <option :value="null" />
                        <option
                            v-for="(evaluation, indexEval) of evaluations"
                            :key="indexEval"
                            :value="evaluation"
                        >
                            {{ evaluation.evaluation_administrator_model_name }}
                        </option>
                        </b-form-select>
                    </b-form-group>
                    <form-error
                        :errors="errors['evaluationId']"
                        :field-name="'evaluationId'"
                    />
                    <div v-if="selectedModel">
                        <div v-if="Object.keys(selectedModel).length > 0 && !selectedModel.isActive"
                        style="margin: 0px 0px 5px 10px ; color: red; font-size: 12px; text-align: left"
                        >
                            {{$t('label_evaluation_administrator_evaluations_isInactive')}}
                        </div>
                    </div>
                    <b-form-group label-class="text-sm-left">
                        <template slot="label">
                        <!--title-->
                        {{
                            $t(
                            "label_evaluation_administrator_evaluations_evaluationTarget"
                            )
                        }}
                        </template>
                        <b-form-input
                        id="label_evaluation_administrator_evaluations_evaluationTarget"
                        v-model="
                            model.evaluation_administrator_evaluations_evaluationTarget
                        "
                        type="text"
                        required
                        />
                    </b-form-group>
                    <form-error
                        :errors="
                        errors[
                            'evaluation_administrator_evaluations_evaluationTarget'
                        ]
                        "
                        :field-name="'evaluationId'"
                    />
                    <b-form-group label-class="text-sm-left">
                        <template slot="label">
                        <!--title-->
                        {{
                            $t(
                            "label_evaluation_administrator_evaluations_evaluationName"
                            )
                        }}
                        </template>
                        <b-form-input
                        id="label_evaluation_administrator_evaluations_evaluationName"
                        v-model="
                            model.evaluation_administrator_evaluations_evaluationName
                        "
                        type="text"
                        required
                        />
                    </b-form-group>
                    <form-error
                        :errors="
                        errors[
                            'evaluation_administrator_evaluations_evaluationName'
                        ]
                        "
                        :field-name="'evaluation_administrator_evaluations_evaluationName'"
                    />
                    <b-form-group label-class="text-sm-left">
                        <template slot="label">
                        <!--title-->
                        {{
                            $t(
                            "label_evaluation_administrator_evaluations_evaluationShortName"
                            )
                        }}
                        </template>
                        <b-form-input
                        id="label_evaluation_administrator_evaluations_evaluationShortName"
                        v-model="
                            model.evaluation_administrator_evaluations_evaluationShortName
                        "
                        type="text"
                        required
                        />
                    </b-form-group>
                    <b-form-group label-class="text-sm-left">
                        <template slot="label">
                            {{$t("label_evaluation_administrator_evaluations_auditType")}}
                        </template>
                        <b-form-select
                            id="label_evaluation_administrator_evaluations_auditType"
                            v-model="model.evaluation_administrator_evaluations_auditType"
                            style="width: 100%"
                        >
                            <option
                            v-for="(type, indexAudit) of auditTypes"
                            :key="indexAudit"
                            :value="type"
                            >
                            {{ $t(type) }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label-class="text-sm-left">
                        <template slot="label">
                        <!--title-->
                        {{
                            $t(
                            "label_evaluation_administrator_evaluation_assignedEvaluators"
                            )
                        }}
                        </template>
                        <multiselect-custom
                        v-model="
                            model.evaluation_administrator_evaluations_assignEvaluator
                        "
                        :multiple="true"
                        :taggable="false"
                        track-by="id"
                        :hide-selected="true"
                        :options="users"
                        :custom-label="userName"
                        @input="forceUp"
                        />
                    </b-form-group>
                    <b-form-group label-class="text-sm-left">
                        <template slot="label">
                        <!--title-->
                        {{
                            $t(
                            "label_evaluation_administrator_evaluation_assignedResposible"
                            )
                        }}
                        </template>
                        <multiselect-custom
                        v-model="
                            model.evaluation_administrator_evaluations_assignedResposible
                        "
                        :multiple="true"
                        :taggable="false"
                        track-by="id"
                        :hide-selected="true"
                        :options="users"
                        :custom-label="userName"
                        @input="forceUp"
                        />
                    </b-form-group>
                    <b-form-group label-class="text-sm-left">
                        <template slot="label">
                        <!--title-->
                        {{ $t("label_evaluation_traceabilityNumber") }}
                        </template>
                        <b-form-input
                        id="label_evaluation_administrator_evaluations_traceability"
                        v-model="
                            model.evaluation_administrator_evaluations_traceability
                        "
                        type="text"
                        required
                        />
                    </b-form-group>
                    <b-form-group label-class="text-sm-left">
                        <template slot="label">
                        <!--title-->
                        {{ $t("label_evaluation_evaluationMatrix_previousSeal") }}
                        </template>
                        <b-form-input
                        id="label_evaluation_evaluationMatrix_previousSeal"
                        v-model="model.evaluation_evaluationMatrix_previousSeal"
                        type="text"
                        required
                        />
                    </b-form-group>
                    </b-container>
                </b-form>
                </b-col>
            </b-row>
            </b-container>
            <div v-if="success">
            {{ $t("label_evaluation_administrator_model_save_success") }}
            </div>
            <div
            v-if="success"
            slot="modal-footer"
            class="w-100"
            style="text-align: right"
            >
            <b-btn variant="second" @click="clearModal()"> {{ $t("label_evaluation_administrator_ok") }} </b-btn>
            </div>
            <div
            v-if="!success"
            slot="modal-footer"
            class="w-100"
            style="text-align: right"
            >
            <b-btn variant="primary"
                @click="saveEvaluation()"
                :disabled="!selectedModel || !selectedModel.isActive"
                >
                {{ $t(modalInfo.actionName) }}
            </b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script >
import { validateField } from "../../../../utils/commons";
import FormError from "../../../template/_template-error";
import MultiselectCustom from "../../../../utils/multiselect/Multiselect";
import { mapGetters } from "vuex";
import { axiosCall } from "../../../../utils/axiosCall";

export default {
  name: "CreateEvaluationModal",
  components: { MultiselectCustom, FormError },
  data() {
    return {
      editMode: false,
      // eslint-disable-next-line camelcase
      evaluation_administrator_evaluations_assignEvaluator_no_remove: [],
      // eslint-disable-next-line camelcase
      evaluation_administrator_evaluations_assignedResposible_no_remove: [],
      errors: {},
      model: {
        // eslint-disable-next-line camelcase
        businessId: null,
        snapshotId: [],
        evaluation_administrator_evaluations_evaluationName: null,
        label_evaluation_evaluationMatrix_previousSeal: null,
        evaluation_administrator_evaluations_assignedResposible: null,
        evaluationId: null,
      },
      selectedBusiness: null,
      evaluationsList: [],
      success: false,
      business: [],
      selectedTag: null,
      allBusiness: [],
      tags: [],
      evaluations: [],
      snapshots: [],
      users: [],
      selectedBusinessMulti: [],
      selectedBusinessFromDB: [],
      selectedBusinessList: [],
      checked: false,
      validations: {
        snapshotId: ["requiredArr"],
        // eslint-disable-next-line camelcase
        evaluation_administrator_evaluations_evaluationName: ["required"],
        //evaluationId: ["required"],
      },
      auditTypes: ["label_evaluation_administrator_evaluations_auditType_initial",
                    "label_evaluation_administrator_evaluations_auditType_followup",
                    "label_evaluation_administrator_evaluations_auditType_recertification"],
      selectedModel: {}
    };
  },
  props:{
    showModal:{
        type: Boolean,
        default: true
    },
    modalInfo: {
        type: Object,
        default: () => {}
    },
    type:{
        type: String,
        default: ""
    },
    id:{
        type: String,
        default: ""
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.showModal;
      },
      set(newValue) {;
        this.$emit("update:showModal", newValue);
      },
    },
    ...mapGetters(["getUserAccountBusinesses", "getUserAccount"]),
  },
  watch: {
    selectedBusinessMulti: {
      handler() {
        this.selectedBusinessMulti.map((select, index) => {
          if (select !== true) {
            this.model.snapshotId[index] = null;
          }
        });
      },
      deep: true,
    },
    model: {
      handler() {
        if (this.checked) {
          this.validateForm();
        }
      },
      deep: true,
    },
    selectedTag: {
      handler: function () {
        this.selectedTagChanged();
      },
    },
    selectedBusiness: {
      handler: function (newVal) {
        if (newVal) {
          axiosCall({ url: "Snapshots/list/" + newVal, method: "GET" })
            .then((response) => {
              this.snapshots = response.data.snapshots;
            })
            .catch(() => {
            });
          this.selectedBusiness = newVal;
          this.model.businessId = this.selectedBusiness;
        } else {
          this.snapshots = [];
          this.model.businessId = null;
        }
        this.model.snapshotId = [];
      },
    },
  },
  methods: {
    canEdit(evaluation) {
      const userBusiness = (this.getUserAccountBusinesses || []).map(
        (ab) => ab.id
      );
      const evaluationBusiness = evaluation.businessId;
      const found = evaluationBusiness.some((r) => userBusiness.includes(r));
      return found;
    },
    forceUp() {
      this.$forceUpdate();
    },
    selectedTagChanged() {
      this.business = [...[]];
      this.selectedBusinessMulti = [...[]];
      this.allBusiness.map((business) => {
        let include = false;
        business.tags.map((tag) => {
          if (tag.id === this.selectedTag) {
            include = true;
          }
        });
        if (include) {
          this.business.push(business);
        }
      });
      var currTag = this.tags.filter((tag) => tag.id === this.selectedTag);
      // eslint-disable-next-line camelcase
      this.model.evaluation_administrator_evaluations_selectTag =
        currTag.length > 0 ? currTag[0] : null;
    },
    changeSelectedMulti() {},
    userName(user) {
      return user.name + " " + user.lastName;
    },
    clearModal() {
      this.isOpen = false;
      this.model = {
        // eslint-disable-next-line camelcase
        businessId: null,
        snapshotId: [],
        evaluation_administrator_evaluations_evaluationName: null,
        evaluationId: null,
      };
      this.selectedBusiness = null
      this.selectedModel = null
      this.selectedTag = null;
      this.$emit("update:id", null)
      this.success = false;
      this.selectedBusinessList = [...[]];
      this.selectedBusinessFromDB = [...[]];
      this.editMode = false;
    },
    async openModal() {
      await this.getCreationData();
      if (this.id) {
        await axiosCall({ url: "Evaluations/" + this.id, method: "GET" }).then(
          (response) => {
            this.editMode = true;

            this.model.snapshotId = response.data.snapshotId;
            // eslint-disable-next-line camelcase
            this.model.evaluation_administrator_evaluations_evaluationShortName =
              response.data.evaluation_administrator_evaluations_evaluationShortName;
            // eslint-disable-next-line camelcase
            this.model.evaluation_administrator_evaluations_evaluationName =
              response.data.evaluation_administrator_evaluations_evaluationName;
            // eslint-disable-next-line camelcase
            this.model.evaluation_administrator_evaluations_assignEvaluator =
              response.data
                .evaluation_administrator_evaluations_assignEvaluator || [];
            // eslint-disable-next-line camelcase
            this.evaluation_administrator_evaluations_assignEvaluator_no_remove =
              [
                ...(response.data
                  .evaluation_administrator_evaluations_assignEvaluator || []),
              ];
            // eslint-disable-next-line camelcase
            this.model.evaluation_administrator_evaluations_assignedResposible =
              response.data
                .evaluation_administrator_evaluations_assignedResposible || [];
            // eslint-disable-next-line camelcase
            this.evaluation_administrator_evaluations_assignedResposible_no_remove =
              [
                ...(response.data
                  .evaluation_administrator_evaluations_assignedResposible ||
                  []),
              ];
            // eslint-disable-next-line camelcase
            this.model.evaluation_administrator_evaluations_traceability =
              response.data.evaluation_administrator_evaluations_traceability;
            // eslint-disable-next-line camelcase
            this.model.evaluation_evaluationMatrix_previousSeal =
              response.data.evaluation_evaluationMatrix_previousSeal;
            // eslint-disable-next-line camelcase
            this.model.evaluation_administrator_evaluations_evaluationTarget =
              response.data.evaluation_administrator_evaluations_evaluationTarget;
            this.model.evaluationId = response.data.evaluationId;
            this.selectedModel = this.evaluations.find(i => i.id === this.model.evaluationId)
            this.model.id = response.data.id;
            if(response.data.evaluation_administrator_evaluations_auditType)
              this.model.evaluation_administrator_evaluations_auditType = response.data.evaluation_administrator_evaluations_auditType
            this.selectedBusinessFromDB = response.data.businessId;
            if (response.data.evaluation_administrator_evaluations_selectTag) {
              this.selectedTag =
                response.data.evaluation_administrator_evaluations_selectTag.id;
              // eslint-disable-next-line camelcase
              this.model.evaluation_administrator_evaluations_selectTag =
                response.data.evaluation_administrator_evaluations_selectTag;
              this.selectedTagChanged();
              this.$emit("update:type", "multi")
            } else {
                this.$emit("update:type", "single")
            }
            this.allBusiness.map((business) => {
              if (response.data.businessId.includes(business.id)) {
                const businessSelectedSnapshot = { ...business };
                business.snapShots.map((snap) => {
                  if (this.model.snapshotId.includes(snap.id)) {
                    businessSelectedSnapshot.snapshot = snap;
                  }
                });
                delete businessSelectedSnapshot.snapShots;
                this.selectedBusinessList.push(businessSelectedSnapshot);
              }
            });
          }
        );
      } else {
        this.selectedTag = this.tags.length > 0 ? this.tags[0].id : null;
      }
    },
    saveEvaluation() {
      this.checked = true;
      if (this.validateForm()) {
        var data = this.model;
        data.evaluationId = this.selectedModel.id
        data.snapshotId = data.snapshotId.filter((snapshotId) => snapshotId);
        const businessId = [];
        if (this.type === "single") {
          businessId.push(this.selectedBusiness);
          delete this.model.evaluation_administrator_evaluations_selectTag;
        } else if (this.type === "multi") {
          this.selectedBusinessMulti.map((selectedBusiness, index) => {
            if (selectedBusiness) {
              businessId.push(this.business[index].id);
            }
          });
        }
        data.businessId = [...businessId];
        if (this.selectedBusinessFromDB.length > 0) {
          data.businessId = [...this.selectedBusinessFromDB];
        }
        data.evaluation_administrator_evaluations_auditType = this.model.evaluation_administrator_evaluations_auditType
        axiosCall({ url: "Evaluations/newEvaluation", method: "POST", data })
          .then(() => {
            this.$emit("refreseh")
            this.isOpen = false;
            //this.medium-titleAllEvaluations();

          })
          .catch(() => {
          });
      }
    },
    validateForm() {
      this.checked = true;
      this.errors = { ...{} };
      var keys = Object.keys(this.model);
      for (var i = 0; i < keys.length; i++) {
        validateField(
          keys[i],
          this.model[keys[i]],
          this.validations[keys[i]],
          this.errors
        );
      }
      var errors = Object.keys(this.errors)
        .filter((s) => this.errors[s])
        .filter((r) => this.errors[r].length > 0);
      return errors.length === 0;
    },

    async getCreationData() {
      await axiosCall({
        url: "EvaluationModels/getDataForCreation",
        method: "GET",
      })
        .then((response) => {
          this.allBusiness = response.data.business.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
          this.evaluations = response.data.evaluation;
          this.users = response.data.users;
          this.tags = response.data.tags;
        })
        .catch(() => {
        });
    },
  },
};
</script >
<style src="../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css" ></style >
<style lang="sass" scoped >

@import "../../../../assets/css/variables"

.cardContainer
  border: 1px solid #000000
  width: 100%
  padding: 30px 40px

.cardContainer h5
  text-align: center
  width: 100%

h2
  color: black
  margin: 1em 0

legend
  font-weight: bold
  font-size: 14px !important

.businessName
  font-size: 12px !important
  text-align: left

h4
  font-size: 1.3rem
  text-transform: uppercase
</style >
<style lang="sass">
.customPagination  li  a
  color: #00a29c !important

.customPagination  li.active  a,
.customPagination  li  a:hover
  background-color: #00a29c !important
  border-color: #00a29c !important
  color: #ffffff !important
</style>
